<template>
  <div class="block-code-embed">
    <div class="block-code-embed__inner container">
      <client-only>
        <div :id="containerId" class="block-code-embed__container" />
        <div ref="codeContainer" class="block-code-embed__code" v-html="embedCode" />
      </client-only>
    </div>
    <pt-blob v-if="getDisplayBlob(section)" v-bind="getBlobBindings(section)" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, nextTick, onMounted } from 'vue';
import { useSectionProps } from '~/composables/blocks';
import { useBlob } from '~/composables/blob';
import type { SectionProps } from '~/types/components';
import PtBlob from '~/components/global/elements/PtBlob.vue';
import { executeEmbeddedScripts } from '~/utils/embedScripts';

const props: SectionProps = defineProps(useSectionProps());
const { getDisplayBlob, getBlobBindings } = useBlob();
const codeContainer = ref<HTMLElement | null>(null);

const containerId = computed(() => {
  if (props.section.container_id) {
    return props.section.container_id;
  }
  return `code-embed-${props.sectionIndex}`;
});

const embedCode = computed(() => {
  return props.section.code || '';
});

// Execute scripts after v-html injection (Vue doesn't execute script tags in v-html)
onMounted(() => {
  nextTick(() => {
    if (!codeContainer.value || !embedCode.value) {
      return;
    }
    executeEmbeddedScripts(codeContainer.value);
  });
});
</script>
